import { useI18n } from "@/context/I18nContext";
import { fmtQty } from "@/lib/wmDigits";
import { OPS } from "@/constants/testIds";

const C = OPS.wm;

/**
 * «المسجل اليوم: ٣٠» — the read-only chip beside a day-sheet line.
 *
 * It shows the BRANCH total for that item on that date, which is the whole
 * point of D14: the evening shift sees the morning's 30 and adds its own 25
 * instead of overwriting it. Tapping it opens the record panel; below
 * `wm_branch_manage` that panel lists only the caller's own rows and says how
 * many colleague rows are not shown.
 */
export function RecordedTodayChip({ chip, itemId, onOpen }) {
    const { t, lang } = useI18n();
    if (!chip || !chip.quantity) return null;
    return (
        <button type="button" data-testid={C.sheet.chip(itemId)} onClick={onOpen}
                className="inline-flex max-w-full items-center gap-1 rounded-full bg-[color:var(--brand-sky)] px-2 py-0.5 text-[11px] font-semibold text-[color:var(--ink)] hover:brightness-95">
            <span className="truncate">{t("wm_recorded_today")}:</span>
            <bdi dir="ltr" className="tabular-nums">{fmtQty(chip.quantity, lang)}</bdi>
            {chip.count > 1 ? <span className="opacity-70">({chip.count})</span> : null}
        </button>
    );
}
